/* eslint-disable no-empty-label */
import Layout from '@/views/layout/Layout'
import Empty from '@/views/empty'
const InspectionOrder = () => import('@/views/order/inspectionOrder')
const InspectionOrderDetail = () => import('@/views/order/inspectionOrderDetail')
const ProjectOrder = () => import('@/views/order/projectOrder')
const ProjectOrderDetail = () => import('@/views/order/projectOrderDetail')
const RepairOrder = () => import('@/views/order/repairOrder')
const ItemOrder = () => import('@/views/order/itemOrder')
const ItemOrderDetail = () => import('@/views/order/itemOrderDetail')
const WarningOrder = () => import('@/views/order/warningOrder')
const RepairDetail = () => import('@/views/order/repairOrderDetail')
const OrderCreate = () => import('@/views/order/orderCreate')
const RepairCreate = () => import('@/views/order/repairCreate')
const InspectionCreate = () => import('@/views/order/inspectionCreate')
const ChangeFeeAudit = () => import('@/views/projectAudit/changeFeeAudit')
const Personnel = () => import('@/views/system/personnel')
const Role = () => import('@/views/system/role')
const ServiceStation = () => import('@/views/system/serviceStation')
const Enterprise = () => import('@/views/system/enterprise')
const ItemTypeManage = () => import('@/views/system/itemTypeManage/index')
const ProjectTypeManage = () => import('@/views/system/projectTypeManage/index')
const ProjectCreate = () => import('@/views/order/orderCreate')

///************项目管理************
//项目管理-工程项目
const EngineeringProjectManage = () => import('@/views/engineeringSetting/engineeringProjectManage/index')
const EngineeringProjectCreate = () => import('@/views/engineeringSetting/engineeringProjectManage/engineeringCreate')
const EngineeringProjectDetail = () => import('@/views/engineeringSetting/engineeringProjectManage/engineeringDetail')
//项目管理-巡检项目
const MonitorProcess = () => import('@/views/engineeringSetting/monitorProcess/monitorProcess')
const MonitorDetail = () => import('@/views/engineeringSetting/monitorProcess/monitorDetail')

const Engineer = () => import('@/views/resource/engineer')
const ResourceClient = () => import('@/views/resource/client')
const ClientContact = () => import('@/views/resource/clientContact')
const OutsourceRecord = () => import('@/views/resource/outsourceRecord')

const EmployeeList = () => import('@/views/resource/employeeList')
const EmployeeAddEdit = () => import('@/views/resource/employeeAddEdit')
const PersonOutsourceAddEdit = () => import('@/views/resource/personOutsourceAddEdit')
const ClientOutsourceAddEdit = () => import('@/views/resource/clientOutsourceAddEdit')
const ClientOutsourceDetail = () => import('@/views/resource/clientOutsourceDetail')
const PersonnelOutsourceDetail = () => import('@/views/resource/personnelOutsourceDetail')

const ContractList = () => import('@/views/contract/contractList')
const ContractCreate = () => import('@/views/contract/contractCreate')
const ContractDetail = () => import('@/views/contract/contractDetail')
const ProjectProcess = () => import('@/views/process/projectProcess')
const ProjectSOP = () => import('@/views/process/projectSOP')
const ServicePlanManage = () => import('@/views/engineeringSetting/monitorProcess/servicePlanManage')

// 统计分析
const WorkOrder = () => import('@/views/analyse/workOrder/index')
const Performancesta = () => import('@/views/analyse/performancesta/index')
const AreaPersonBusy = () => import('@/views/analyse/workOrder/areaPersonBusy')//区域人员繁忙度
const AreaBusy = () => import('@/views/analyse/workOrder/areaBusy')//区域繁忙度
const AllPersonBusy = () => import('@/views/analyse/workOrder/allPersonBusy')//所有人员繁忙度
const QutletsOrder = () => import('@/views/analyse/workOrder/qutletsOrder')//网点工单统计

/**
 * @2019/4/18
 * @author: huiming
 * desc:  这里面是默认所有权限都有的路由 依次介绍一下所有的属性 path name component不介绍了
 * 加这些额外的参数主要还是给左侧的sidebar用的
 * 1. hidden 表示不将该路由加载到左侧的栏
 * 2. name 正常来说没有hidden属性必须要有name属性，这个是左侧栏的的名字
 * 3. alwaysShow， 如果设置了这个属性，不管其子路由有没有，这一栏都会显示（用处不大，建议别设置）
 * 4. mate: {
        roles: ["admin", "editor"]  访问权限
        title: 将改变网页的title，不设置默认为项目名
        icon： iconfont图标  建议所有一级设置，二级不要设置
      }
 */
const ConfigManage = () => import('@/views/system/configManage')

export default [
  {
    path: '/order',
    component: Layout,
    name: 'Order',
    menuName: '工单管理',
    meta: {
      icon: 'icon-dingdanguanli'
    },
    children: [
      {
        path: 'inspection',
        name: 'InspectionOrder',
        component: InspectionOrder,
        menuName: '巡检单',
        meta: { title: '巡检单', tagName: '巡检单', keepAlive: true }
      },
      {
        path: 'inspection_detail',
        name: 'InspectionOrderDetail',
        component: InspectionOrderDetail,
        hidden: true,
        meta: { title: '巡检单详情', tagName: '巡检单详情' }
      },
      {
        path: 'project',
        name: 'ProjectOrder',
        component: ProjectOrder,
        menuName: '工程项目单',
        meta: { title: '工程项目单', tagName: '工程项目单' }
      },
      {
        path: 'project_detail',
        name: 'ProjectOrderDetail',
        component: ProjectOrderDetail,
        hidden: true,
        meta: { title: '工程单详情', tagName: '工程单详情' }
      },
      {
        path: 'repair',
        name: 'RepairOrder',
        component: RepairOrder,
        menuName: '维修单',
        meta: { title: '维修单', tagName: '维修单', keepAlive: true }
      },
      {
        path: 'itemOrder',
        name: 'ItemOrder',
        component: ItemOrder,
        menuName: '事项单',
        meta: { title: '事项单', tagName: '事项单', keepAlive: true }
      },
      {
        path: 'itemOrder_detail',
        name: 'ItemOrderDetail',
        component: ItemOrderDetail,
        hidden: true,
        meta: { title: '事项单详情', tagName: '事项单详情' }
      },
      {
        path: 'repair_detail',
        name: 'RepairDetail',
        component: RepairDetail,
        hidden: true,
        meta: { title: '维修单详情', tagName: '维修单详情' }
      },
      {
        path: 'warning',
        name: 'WarningOrder',
        component: WarningOrder,
        menuName: '故障预警',
        meta: { title: '故障预警', tagName: '故障预警' }
      },
      {
        path: 'order_create',
        name: 'OrderCreate',
        component: OrderCreate,
        menuName: '新建工单',
        meta: { title: '新建工单', tagName: '新建工单' }
      },
      {
        path: 'repair_create',
        name: 'RepairCreate',
        component: RepairCreate,
        hidden: true,
        meta: { title: '新建维修单', tagName: '新建维修单' }
      },
      {
        path: 'project_create',
        name: 'ProjectCreate',
        component: ProjectCreate,
        hidden: true,
        meta: { title: '新建工程单', tagName: '新建工程单' }
      },
      {
        path: 'inspection_create',
        name: 'InspectionCreate',
        component: InspectionCreate,
        hidden: true,
        meta: { title: '新建巡检单', tagName: '新建巡检单' }
      }
    ]
  },
  {
    path: '/project_audit',
    component: Layout,
    menuName: '项目审核',
    meta: {
      icon: 'icon-form'
    },
    children: [
      {
        path: 'change_fee_audit',
        name: 'ChangeFeeAudit',
        component: ChangeFeeAudit,
        menuName: '工程单费用审核',
        meta: { title: '工程单费用审核', tagName: '工程单费用审核' }
      }
    ]
  },
  {
    path: '/process',
    component: Layout,
    menuName: '项目管理',
    meta: { icon: 'icon-set' },
    children: [
      {
        path: 'undertaking',
        menuName: '项目设置',
        component: Empty,
        meta: { title: '项目设置', tagName: '项目设置' },
        children: [
          {
            path: 'monitor',
            menuName: '巡检项目设置',
            component: MonitorProcess,
            name: 'MonitorProcess',
            meta: { title: '巡检项目设置', tagName: '巡检项目设置' }
          },
          {
            path: 'project',
            menuName: '工程单项目设置',
            component: ProjectProcess,
            name: 'ProjectProcess',
            meta: { title: '工程单项目设置', tagName: '工程单项目设置' }
          },
          {
            path: 'project_sop',
            hidden: true,
            name: 'ProjectSOP',
            component: ProjectSOP,
            meta: { title: 'SOP设置', tagName: 'SOP设置' }
          },
          {
            path: 'service_plan_manage',
            menuName: '服务计划管理',
            component: ServicePlanManage,
            name: 'ServicePlanManage',
            meta: { title: '服务计划管理', tagName: '服务计划管理' }
          }
        ]
      }
    ]
  },
  {
    path: '/engineeringProjectSetting',
    component: Layout,
    menuName: '工程设置',
    meta: { icon: 'icon-system' },
    children: [
      {
        path: 'engineeringProjectManage',
        name: 'EngineeringProjectManage',
        component: EngineeringProjectManage,
        menuName: '工程项目管理',
        meta: { title: '工程项目管理', tagName: '工程项目管理' }
      },
      {
        path: 'engineeringProjectCreate',
        name: 'EngineeringProjectCreate',
        component: EngineeringProjectCreate,
        hidden: true,
        meta: { title: '新建工程项目', tagName: '新建工程项目' }
      },
      {
        path: 'engineeringProjectDetail',
        name: 'EngineeringProjectDetail',
        component: EngineeringProjectDetail,
        hidden: true,
        meta: { title: '工程项目详情', tagName: '工程项目详情' }
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    menuName: '系统设置',
    meta: { icon: 'icon-system' },
    children: [
      {
        path: 'personnel',
        name: 'Personnel',
        component: Personnel,
        menuName: '人员管理',
        meta: { title: '人员管理', tagName: '人员管理' }
      },
      {
        path: 'role',
        name: 'Role',
        component: Role,
        menuName: '角色管理',
        meta: { title: '角色管理', tagName: '角色管理' }
      },
      {
        path: 'service_station',
        name: 'ServiceStation',
        component: ServiceStation,
        menuName: '服务站点管理',
        meta: { title: '服务站点管理', tagName: '服务站点管理' }
      },
      {
        path: 'enterprise',
        name: 'Enterprise',
        component: Enterprise,
        menuName: '企业设置',
        meta: { title: '企业设置', tagName: '企业设置' }
      },
      {
        path: 'itemTypeManage',
        name: 'ItemTypeManage',
        component: ItemTypeManage, // ItemTypeManage
        menuName: '事项类型',
        meta: { title: '事项类型', tagName: '事项类型' }
      },
      {
        path: 'configManage',
        name: 'ConfigManage',
        component: ConfigManage,
        menuName: '配置管理',
        meta: { title: '配置管理', tagName: '配置管理' }
      },
      {
        path: 'projectTypeManage',
        name: 'ProjectTypeManage',
        component: ProjectTypeManage, // ItemTypeManage
        menuName: '任务类型',
        meta: { title: '任务类型', tagName: '任务类型' }
      },
    ]
  },
  {
    path: '/resource',
    component: Layout,
    menuName: '资源管理',
    meta: { icon: 'icon-textile-products' },
    children: [
      {
        path: 'engineer',
        name: 'Engineer',
        component: Engineer,
        menuName: '工程师管理',
        meta: { title: '工程师管理', tagName: '工程师管理' }
      },
      {
        path: 'client',
        name: 'ResourceClient',
        component: ResourceClient,
        menuName: '银行客户管理',
        meta: { title: '银行客户管理', tagName: '银行客户管理' }
      },
      {
        path: 'client_contact',
        name: 'clientContact',
        menuName: '客户联系人',
        component: ClientContact,
        meta: { title: '客户联系人', tagName: '客户联系人' }
      },
      {
        path: 'outsource_record',
        name: 'OutsourceRecord',
        menuName: '外包商备案',
        component: OutsourceRecord,
        meta: { title: '外包商备案', tagName: '外包商备案' }
      },
      {
        path: 'employee_list',
        name: 'EmployeeList',
        hidden: true,
        component: EmployeeList,
        meta: { title: '人员列表', tagName: '人员列表' }
      },
      {
        path: 'employee_add_edit',
        name: 'EmployeeAddEdit',
        hidden: true,
        component: EmployeeAddEdit,
        meta: { title: '人员备案', tagName: '人员备案' }
      },
      {
        path: 'person_outsource_add_edit',
        name: 'PersonOutsourceAddEdit',
        hidden: true,
        component: PersonOutsourceAddEdit,
        meta: { title: '个人外包商备案', tagName: '个人外包商备案' }
      },
      {
        path: 'client_outsource_add_edit',
        name: 'ClientOutsourceAddEdit',
        hidden: true,
        component: ClientOutsourceAddEdit,
        meta: { title: '企业外包商备案', tagName: '企业外包商备案' }
      },
      {
        path: 'client_outsource_detail',
        name: 'ClientOutsourceDetail',
        hidden: true,
        component: ClientOutsourceDetail,
        meta: { title: '企业外包商详情', tagName: '企业外包商详情' }
      },
      {
        path: 'personnel_outsource_detail',
        name: 'PersonnelOutsourceDetail',
        hidden: true,
        component: PersonnelOutsourceDetail,
        meta: { title: '个人外包商详情', tagName: '个人外包商详情' }
      }
    ]
  },
  {
    path: '/contract',
    component: Layout,
    menuName: '合同管理',
    meta: { icon: 'icon-hetong' },
    children: [
      {
        path: 'contract_list',
        name: 'ContractList',
        menuName: '合同管理',
        component: ContractList,
        meta: { title: '合同管理', tagName: '合同管理' }
      },
      {
        path: 'contract_create',
        name: 'ContractCreate',
        menuName: '添加合同',
        component: ContractCreate,
        meta: { title: '添加合同', tagName: '添加合同' }
      },
      {
        path: 'contract_detail',
        name: 'ContractDetail',
        hidden: true,
        component: ContractDetail,
        meta: { title: '合同详情', tagName: '合同详情' }
      }
    ]
  },
  {
    path: '/analyse',
    component: Layout,
    menuName: '统计分析',
    meta: { icon: 'icon-textile-products' },
    children: [
      {
        path: 'workorder',
        name: 'statistics',
        component: WorkOrder,
        menuName: '工单统计概览',
        meta: { title: '工单统计概览', tagName: '工单统计概览' },
      },
      {
        path: 'areaPersonBusy',
        name: 'areaPersonBusy',
        component: AreaPersonBusy,
        menuName: '区域人员繁忙度',
        meta: { title: '区域人员繁忙度', tagName: '区域人员繁忙度' },
      },
      {
        path: 'areaBusy',
        name: 'areaBusy',
        component: AreaBusy,
        menuName: '区域繁忙度',
        meta: { title: '区域繁忙度', tagName: '区域繁忙度' },
      },
      {
        path: 'allPersonBusy',
        name: 'allPersonBusy',
        component: AllPersonBusy,
        menuName: '所有人员繁忙度',
        meta: { title: '所有人员繁忙度', tagName: '所有人员繁忙度' },
      },
      {
        path: 'qutletsOrder',
        name: 'qutletsOrder',
        component: QutletsOrder,
        menuName: '网点工单统计',
        meta: { title: '网点工单统计', tagName: '网点工单统计' },
      },
      {
        path: 'performancesta',
        name: 'Performancesta',
        component: Performancesta,
        menuName: '绩效统计',
        meta: { title: '绩效统计', tagName: '绩效统计' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true },

]



// WEBPACK FOOTER //
// ./src/router/asyncRouterMap.js